import { profileActionTypes } from "../actions/index";


export const initialState = {
    transaction: undefined,
}

export const transactionReducer = (state = initialState, action) => {
    switch (action.type) {
        case profileActionTypes.EDIT_TRANSACTION:
            return {
                ...state,
                ...action.payload,
            }
        default:
            return state
    }
}